import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=03e3200e&"
var script = {}
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=03e3200e&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports